<template>
  <div ref="tab" class="borrowing-box">
    <div class="borrowing-headers" :class="'headers-background-'+borrowingInfo.applyStatus">
      <headers
        :headInfo="{headUrl: borrowingInfo.dingDingPhotoPath, dingdingUserId:borrowingInfo.currentApplyDingDingId, userName: borrowingInfo.currentApplyEmployeeName, approver: borrowingInfo.nextApprover, approvalState: borrowingInfo.applyStatus }"
      ></headers>
    </div>
    <div ref="borrowing_tab" class="borrowing-tab">
      <tab :tabconfig="tabconfig"></tab>
    </div>
    <div class="mian-box">
      <div class="borrowing-info d_jump">
        <div class="borrowing-info-content">
          <div class="borrowing-info-box">
            <div class="borrowing-info-label">核算部门</div>
            <div class="borrowing-info-content">{{borrowingInfo.accountingDeptName}}</div>
          </div>
          <div class="borrowing-info-box">
            <div class="borrowing-info-label">借款项目</div>
            <router-link
              v-if="borrowingInfo.projectType=='Business'"
              class="borrowing-info-content bg-color"
              :to="{name:'projectInfo',query:{projectCode:borrowingInfo.projectCode}}"
            >{{borrowingInfo.projectName}}</router-link>
            <div v-else class="borrowing-info-content">{{borrowingInfo.projectName}}</div>
          </div>
          <div class="borrowing-info-box">
            <div class="borrowing-info-label">支出项目</div>
            <div class="borrowing-info-content">{{borrowingInfo.payItemName}}</div>
          </div>
          <div class="borrowing-info-box">
            <div class="borrowing-info-label">考核单元</div>
            <div class="borrowing-info-content">{{borrowingInfo.financialDeptName}}</div>
          </div>
          <div class="borrowing-info-box">
            <div class="borrowing-info-label">借款公司</div>
            <div class="borrowing-info-content">{{borrowingInfo.borrowingCompanyName}}</div>
          </div>
          <div class="borrowing-info-box">
            <div class="borrowing-info-label">借款种类</div>
            <div class="borrowing-info-content">{{borrowingInfo.borrowingTypeName}}</div>
          </div>
          <div class="borrowing-info-box">
            <div class="borrowing-info-label">借款结算人</div>
            <div
              class="borrowing-info-content"
            >{{borrowingInfo.borrowingEmployeeName+"-"+borrowingInfo.borrowingDeptName}}</div>
          </div>
          <div class="borrowing-info-box">
            <div class="borrowing-info-label">借款金额</div>
            <div class="borrowing-info-content">{{borrowingInfo.borrowingAmount|NumFormat}}元</div>
          </div>
          <div class="borrowing-info-box">
            <div class="borrowing-info-label">借款事由</div>
            <div
              class="borrowing-info-content"
              v-html="$options.filters.textareaToFormat(borrowingInfo.borrowingReason)"
            ></div>
          </div>
          <div class="borrowing-info-box">
            <div class="borrowing-info-label">实际用途</div>
            <div
              class="borrowing-info-content"
              v-html="$options.filters.textareaToFormat(borrowingInfo.actualReimSummary)"
            ></div>
          </div>
          <div class="borrowing-info-box">
            <div class="borrowing-info-label">相关文档</div>
            <div class="borrowing-info-content">
              <filebox message="暂无借款相关文档" :fileInfo="fileInfo"></filebox>
            </div>
          </div>
        </div>
        <div v-if="borrowingInfo.purchaseInfo">
          <div class="divide-line"></div>
          <!--采购信息开始-->
          <div class="purchaseInfo-content">
            <div class="purchase-order">
              <div class="purchase-order-label">采购申请信息</div>
              <div class="purchase-info-box">
                <div class="purchase-info-label">采购项目</div>
                <div class="purchase-info-content">{{borrowingInfo.purchaseInfo.purchaseKindName}}</div>
              </div>
              <div class="purchase-info-box">
                <div class="purchase-info-label">采购总金额</div>
                <div
                  class="purchase-info-content"
                >{{borrowingInfo.purchaseInfo.totalPrice|NumFormat}}元（已付金额：{{borrowingInfo.approvePaymentAmounts|NumFormat}}元；未付金额：{{(borrowingInfo.purchaseInfo.totalPrice-borrowingInfo.purchaseInfo.approvePaymentAmounts)|NumFormat}}元）</div>
              </div>
              <div class="purchase-info-box">
                <div class="purchase-info-label">采购分类</div>
                <div class="purchase-info-content">{{borrowingInfo.purchaseInfo.purchaseKindName}}</div>
              </div>
              <div class="purchase-info-box">
                <div class="purchase-info-label">采购需求人</div>
                <div
                  class="purchase-info-content"
                >{{borrowingInfo.purchaseInfo.requirementName+"-"+borrowingInfo.purchaseInfo.requirementDeptName}}</div>
              </div>
              <div class="purchase-info-box">
                <div class="purchase-info-label">采购相关文档</div>
                <div class="purchase-info-content">
                  <filebox message="暂无采购相关文档" :fileInfo="purchaseFileInfo"></filebox>
                </div>
              </div>
              <div
                v-for="(item,index) in borrowingInfo.purchaseInfo.detailsList"
                :key="index"
                class="purchase-orderinfo"
              >
                <div class="orderinfo-title-box">
                  <div class="orderinfo-title">供货商</div>
                  <div class="orderinfo-supplier">{{item.mainSupplierName}}</div>
                </div>
                <div class="orderinfo-title-box">
                  <div class="orderinfo-title">物品</div>
                  <div class="orderinfo-supplier">{{item.goodsName}}</div>
                </div>
                <div class="orderinfo-foot">
                  <div class="first-child">单价</div>
                  <div class="orderinfo-amount">{{item.mainSupplierPrice|NumFormat}}元</div>
                  <div class="third-child">合计金额</div>
                  <div class="orderinfo-amount">{{item.mainSupplierTotalPrice|NumFormat}}元</div>
                </div>
              </div>
              <div class="purchase-process">
                <lite-process :approvalList="borrowingInfo.purchaseInfo.approvalList"></lite-process>
              </div>
            </div>
          </div>
          <!--采购信息结束-->
        </div>
        <div class="divide-line"></div>
        <!--收款账户信息开始-->
        <div class="purchaseInfo-content">
          <div class="purchase-order">
            <div class="purchase-order-label">收款账户信息</div>
            <div class="purchase-info-box">
              <div class="purchase-info-label">收款人</div>
              <div class="purchase-info-content">{{borrowingInfo.payeePersonName}}</div>
            </div>
            <div class="purchase-info-box">
              <div class="purchase-info-label">收款账号</div>
              <div class="purchase-info-content">{{borrowingInfo.payeeAccount}}</div>
            </div>
            <div class="purchase-info-box">
              <div class="purchase-info-label">开户行</div>
              <div class="purchase-info-content">{{borrowingInfo.payeeDepositBank}}</div>
            </div>
          </div>
        </div>
        <!--收款账户信息结束-->
        <div class="divide-line"></div>
      </div>
      <div class="process d_jump">
        <process
          :approvalList="borrowingInfo.approvalList"
          :applyEmployeeID="borrowingInfo.applyEmployeeID"
        ></process>
      </div>
    </div>
    <div class="borrowing-foot">
      <exefoot
        :paramInfo="{...paramInfo,approveStep:borrowingInfo.nextApproveStep}"
        v-if="borrowingInfo.nextApproverId&&borrowingInfo.nextApproverId.indexOf(userInfo.employeeID)>-1&&borrowingInfo.applyStatus=='SUBMIT'"
      ></exefoot>
      <selffoot
        :paramInfo="paramInfo"
        :urgeInfo="{approverUserId:borrowingInfo.nextApproverUserId,applyEmployeeName:borrowingInfo.currentApplyEmployeeName, applyTypeName:'借款申请'}"
        v-else-if="borrowingInfo.applyEmployeeID==userInfo.employeeID&&borrowingInfo.applyStatus=='SUBMIT'"
      ></selffoot>
      <passfoot :paramInfo="paramInfo" v-else></passfoot>
    </div>
  </div>
</template>
<script>
import liteProcess from "@/components/Approval/ApprovalProcess/approvalProcess_Lite";
import headers from "@/components/Approval/ApprovalHead/index";
import tab from "@/components/Share/Tab";
import order from "@/components/Share/Table/Order";
import process from "@/components/Approval/ApprovalProcess/index";
import exefoot from "@/components/Approval/ApprovalFoot/approvalExeFoot";
import selffoot from "@/components/Approval/ApprovalFoot/approvalSelfFoot";
import passfoot from "@/components/Approval/ApprovalFoot/approvalPassFoot";
import filebox from "@/components/Share/Preview/fileBox";
import { mapState, mapMutations } from "vuex";
import http from "@/utils/http";
export default {
  data() {
    return {
      paramInfo: {},
      borrowingInfo: {},
      fileInfo: {},
      purchaseFileInfo: {},
      tabconfig: {
        defaultValue: 0,
        backFun: this.tabClickBackFun,
        affixNum: 0,
        tabList: [
          { key: 0, value: "申请信息" },
          { key: 1, value: "审批信息" }
        ]
      }
    };
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo
    })
  },
  methods: {
    ...mapMutations(["setTitleInfo"]),
    tabClickBackFun(index) {},
    getPurchaseInfo(applyId, applyTypeId) {
      let _this = this;
      this.$Spin.show();
      return new Promise((resolve, reject) => {
        http
          .get(
            `/api/FD/Borrowing/GetBorrowingApplyInfo?applyId=${applyId}&applyTypeId=${applyTypeId}`
          )
          .then(res => {
            _this.$Spin.hide();
            if (res.data && res.data.data) {
              _this.setTitleInfo({
                title: "",
                bg: res.data.data.applyStatus,
                isMore: true
              });
              _this.fileInfo = {
                filesrcs: res.data.data.attachFilePath,
                filenames: res.data.data.attachFileName
              };
              if (res.data.data.purchaseInfo != null) {
                _this.purchaseFileInfo = {
                  filesrcs: res.data.data.purchaseInfo.quotationPath,
                  filenames: res.data.data.purchaseInfo.quotationFName
                };
              }
              resolve(res.data.data || {});
            } else resolve({});
          });
      });
    }
  },
  async mounted() {
    let _this = this;
    this.$nextTick(() => {
      _this.tabconfig.affixNum = _this.$refs.tab.offsetTop - 1;
      _this.$refs.borrowing_tab.style =
        "top:" + _this.tabconfig.affixNum + "px";
    });
    this.paramInfo = { ...this.$route.query };
    this.borrowingInfo = await this.getPurchaseInfo(
      this.paramInfo.applyId,
      this.paramInfo.applyTypeId
    );
  },
  components: {
    liteProcess,
    headers,
    tab,
    order,
    process,
    exefoot,
    selffoot,
    passfoot,
    filebox
  }
};
</script>
<style lang="less" scoped>
.borrowing-box {
  .borrowing-headers {
    padding: 0 0.4rem;
  }

  .borrowing-tab {
    width: 100%;
    height: 1.44rem;
    position: sticky;
    z-index: 9;
    background: #fff;
    display: flex;
    align-items: center;
  }
  .mian-box {
    padding-bottom: 1.6rem;
    .borrowing-info {
      .divide-line {
        margin-top: 0.4rem;
        width: 100%;
        height: 0.133333rem;
        background: #f5f5f5;
      }
      .borrowing-info-content {
        padding: 0 0.4rem;
        .borrowing-info-box {
          margin-top: 0.533333rem;
          font-size: 0.373333rem;
          display: flex;
          .borrowing-info-label {
            text-align: center;
            flex: 1;
            color: #999;
          }
          .borrowing-info-content {
            margin-left: 0.133333rem;
            width: 80%;
            color: #333333;
          }
          .bg-color{
            color: #55b9fc!important;
          }
        }
        .borrowing-order {
          .borrowing-order-label {
            height: 1.253333rem;
            line-height: 1.253333rem;
            font-size: 0.453333rem;
            color: #333333;
            font-weight: bold;
            border-bottom: 1px solid #eee;
          }
          .borrowing-order-Total {
            height: 1.44rem;
            line-height: 1.44rem;
            font-size: 0.373333rem;
            color: #999999;
            padding-left: 0.4rem;
            span {
              color: #333333;
            }
          }
        }
      }
      .purchaseInfo-content {
        padding: 0 0.4rem;
        margin-bottom: 0.266667rem;
        .purchase-order {
          .purchase-order-label {
            height: 1.253333rem;
            line-height: 1.253333rem;
            font-size: 0.453333rem;
            color: #333333;
            font-weight: bold;
            border-bottom: 1px solid #eee;
          }
          .purchase-info-box {
            margin-top: 0.533333rem;
            font-size: 0.373333rem;
            display: flex;
            .purchase-info-label {
              text-align: center;
              flex: 1;
              color: #999;
            }
            .purchase-info-content {
              margin-left: 0.133333rem;
              width: 80%;
              color: #333333;
            }
          }
          .purchase-process {
            margin-top: 0.4rem;
          }
          .purchase-orderinfo {
            margin-top: 0.533333rem;
            width: 100%;
            font-size: 0.373333rem;
            border: 1px solid #eee;
            .orderinfo-title-box {
              width: 100%;
              border-bottom: 1px solid #eee;
              display: flex;
              text-align: center;
              align-items: center;
              .orderinfo-title {
                min-height: 1.08rem;
                width: 1.333333rem;
                color: #999;
                border-right: 1px solid #eee;
                display: flex;
                align-items: center;
                justify-content: center;
              }
              .orderinfo-supplier {
                flex: 1;
                min-height: 0.8rem;
                color: #333333;
              }
            }
            .borderbottom {
              border-bottom: 1px solid #eee;
              .borderleft {
                min-width: 1.066667rem;
                border-left: 1px solid #eee;
              }
            }
            .orderinfo-foot {
              width: 100%;
              display: flex;
              color: #999;
              .first-child {
                width: 1.333333rem;
              }
              .third-child {
                width: 2rem;
                border-left: 1px solid #eee;
              }
              div {
                height: 1.08rem;
                line-height: 1.08rem;
                text-align: center;
              }
              .orderinfo-amount {
                flex: 1;
                color: #333;
                border-left: 1px solid #eee;
              }
            }
            .handle {
              height: 0.8rem;
              line-height: 0.8rem;
              text-align: right;
              padding-right: 0.4rem;
            }
          }
        }
      }
    }
    .process {
      margin-top: 0.4rem;
      padding: 0 0.4rem;
    }
  }
  .borrowing-foot {
    padding: 0 0.4rem;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 1.6rem;
    background: #fff;
    z-index: 9;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/FD/Borrowing/index.vue